import Common from '../../Common';

interface Search {
	limit?: number
	limit_from?: number
}

const Mobile = class extends Common {
	browse = (userId: id): CustomResponse<MobileBrowse> =>
		this.get(`/user/${userId}/mobile`)

	topUpHistory = (userId: id, simNo: string, search?: Search): CustomResponse<TopupHistory[]> =>
		this.get(`/user/${userId}/mobile/${simNo}/topuphistory`, search)

	topup = (userId: id, simNo: number, topup: number | string) =>
		this.get(`/user/${userId}/mobile/${simNo}/topup/${topup}`)
}

export default Mobile;
